// extracted by mini-css-extract-plugin
export default {"menuBlock":"rH-z","title":"sH-z","nav":"tH-z","flexCell":"uH-z","facetLink":"vH-z"};